import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getRegisterUrl } from '../utils/registroOrigen';
import './SummerEdition.css';

const SummerEdition = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [currentReview, setCurrentReview] = useState(0);
  const [sliderTranslate, setSliderTranslate] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef(null);
  const dragOffset = useRef(0);

  const slides = [
    '/img/landing/hero_slide1.webp',
    '/img/landing/hero_slide2.webp',
    '/img/landing/hero_slide3.webp'
  ];

  const reviews = [
    { name: 'María G.', text: 'Mi hijo ha mejorado muchísimo desde que se unió a Liga ProKids. Le encanta el sistema de logros y está siempre motivado para el siguiente partido.', sub: 'Madre de Alejandro, 9 años' },
    { name: 'Carlos R.', text: 'La organización es excelente y los entrenadores son muy profesionales. Mi hija disfruta cada partido y ha hecho muchos amigos.', sub: 'Padre de Laura, 8 años' },
    { name: 'Ana M.', text: 'Liga ProKids ha sido una experiencia increíble para toda la familia. Los niños aprenden valores importantes mientras se divierten.', sub: 'Madre de Dani, 7 años' }
  ];

  const handleDragStart = (clientX) => {
    dragStart.current = clientX;
    dragOffset.current = 0;
    setIsDragging(true);
  };

  const handleDragMove = (clientX) => {
    if (dragStart.current === null) return;
    dragOffset.current = clientX - dragStart.current;
    setSliderTranslate(dragOffset.current);
  };

  const handleDragEnd = () => {
    if (dragStart.current === null) return;
    const threshold = 50;
    if (dragOffset.current < -threshold && currentReview < reviews.length - 1) {
      setCurrentReview(prev => prev + 1);
    } else if (dragOffset.current > threshold && currentReview > 0) {
      setCurrentReview(prev => prev - 1);
    }
    dragStart.current = null;
    dragOffset.current = 0;
    setSliderTranslate(0);
    setIsDragging(false);
  };

  useEffect(() => {
    // Cargar FontAwesome
    const link = document.createElement('link');
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="summer-landing-wrapper">
      <main>
        {/* SECTION 1: LANDING HERO */}
        <section id="landing">
          {slides.map((src, idx) => (
            <div 
              key={idx}
              className="slider-layer"
              style={{
                position: 'absolute',
                inset: 0,
                background: `url(${src}) center/cover no-repeat`,
                transition: 'opacity 1500ms ease, transform 6500ms ease-out',
                zIndex: idx === slideIndex ? 1 : 0,
                opacity: idx === slideIndex ? 1 : 0,
                transform: idx === slideIndex ? 'scale(1.08)' : 'scale(1)'
              }}
            />
          ))}
          <div id="slider-bg" style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2 }}></div>

          <img src="/img/landing/logo-prokids.png" alt="Logo" id="logo" className="anim-slide-down" />
          <h1 className="anim-slide-left delay-1">SUMMER EDITION</h1>
          <p className="anim-slide-right delay-1 text-1">¿Quieres que tu hijo/a siga compitiendo en verano… o que esté 3 meses parado?</p>
          <p className="anim-slide-left delay-1 text-2">EL FÚTBOL SIN PRESIONES.<br/>EL APRENDIZAJE SIN LÍMITES.<br/>LA EXPERIENCIA QUE TU HIJO/A MERECE VIVIR.</p>
          
          <div className="anim-slide-up delay-2">
            <Link to={getRegisterUrl('summer')} className="button" style={{ width: '100%' }}>
              <span>¡INSCRÍBETE AHORA!</span>
              <br/>
              <span>Regístrate <i className="fa-solid fa-arrow-right"></i> Crea futbolista <i className="fa-solid fa-arrow-right"></i> Compra jornadas</span>
            </Link>
            <p className="text-3">PLAZAS LIMITADAS POR CATEGORÍA Y POSICIÓN</p>
          </div>
        </section>

        {/* SECTION 2: QUÉ ES */}
        <section id="que-es">
          <h2>¿QUÉ ES LA SUMMER EDITION?</h2>
          <div className="row">
            <div className="col">
              <article>
                <p>Un programa <b>formativo, inclusivo y competitivo,</b> con inscripción <b>individual y flexible,</b> que permite a cualquier niño/a de 4 a 14 años (categorías querubín, prebenjamín, benjamín, alevín e infantil) <b>jugar partidos reales</b> cada fin de semana del verano, en un entorno <b>divertido, equilibrado y adaptado</b> a su nivel.</p>
              </article>
              
              <h3>Aquí cada futbolista...</h3>
              <div className="row">
                <div className="card-small">
                  <i className="fa-solid fa-stopwatch icon"></i>
                  <p>Juega mínimo <b>40 minutos reales</b> cada jornada.</p>
                </div>
                <div className="card-small">
                  <i className="fa-solid fa-person-chalkboard icon"></i>
                  <p>Tiene un <b>entrenador guía</b> que rota, arbrita, enseña y fomenta valores.</p>
                </div>
              </div>
              <div className="row">
                <div className="card-small">
                  <i className="fa-solid fa-futbol icon"></i>
                  <p>Vive cada jornada con <b>nuevos retos, compañeros y rivales.</b></p>
                </div>
                <div className="card-small">
                  <i className="fa-solid fa-gift icon"></i>
                  <p>Acumula <b>puntos</b> y consigue nuevos <b>logros</b> cada partido, sube de <b>nivel</b> y desbloquea <b>regalos</b> a través de un <b>ranking individual.</b></p>
                </div>
              </div>
              <a href="/propoints-summer-edition" className="button">AVERIGUA TODO SOBRE NUESTRO SISTEMA PROPOINTS</a>
              
              <div className="card">
                <h4>SU MOMENTO DE BRILLAR</h4>
                <div className="card-content">
                  <p>Más de <b>900 niños/as</b> ya han vivido esta experiencia con resultados <b>espectaculares.</b> Puedes verlo tú mismo en nuestro Instagram <b><a href="https://www.instagram.com/prokids.experience" target="_blank" rel="noreferrer">@prokidsexperience</a>.</b></p>
                  <p>Durante el año, lo hacía como complemento. <b>En verano,</b> Liga ProKids es su <b>única opción</b> para jugar los <b>minutos que necesita</b> para progresar.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: POR QUÉ */}
        <section id="por-que">
          <h2>¿POR QUÉ HEMOS CREADO LA SUMMER EDITION?</h2>
          <div className="row">
            <div className="col">
              <h3>Porque cuando llega el verano, el fútbol se detiene para todos...</h3>
              <div className="row">
                <div className="card-small">
                  <i className="fa-solid fa-xmark icon"></i>
                  <p>No hay liga.</p>
                </div>
                <div className="card-small">
                  <i className="fa-solid fa-xmark icon"></i>
                  <p>No hay entrenamientos.</p>
                </div>
              </div>
              <div className="row">
                <div className="card-small">
                  <i className="fa-solid fa-xmark icon"></i>
                  <p>No hay ritmo competitivo.</p>
                </div>
                <div className="card-small">
                  <i className="fa-solid fa-xmark icon"></i>
                  <p>No hay motivación.</p>
                </div>
              </div>
              <h3>Y eso, para un niño/a que ama el fútbol, es un castigo innecesario.</h3>
              <div className="card">
                <h4>¡EN VERANO NO SE PARA!</h4>
                <div className="card-content">
                  <p>En ProKids, creemos que el <b>verano</b> también debe <b>vivirse en el campo</b>.</p>
                  <p>Hemos diseñado un formato <b>profesional, flexible y motivador</b>, para que cada niño/a pueda seguir <b>creciendo, disfrutando y compitiendo</b> en verano con niños de su edad y nivel en un entorno <b>sano, formativo y divertido</b>.</p>
                  <Link to={getRegisterUrl('summer')} className="button" style={{ width: '100%' }}>
                    <span>¡INSCRÍBETE AHORA!</span>
                    <br/>
                    <span>Regístrate <i className="fa-solid fa-arrow-right"></i> Crea futbolista <i className="fa-solid fa-arrow-right"></i> Compra jornadas</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4: ESPECIAL */}
        <section id="especial">
          <h2>¿QUÉ LA HACE TAN ESPECIAL?</h2>
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="card-small"><i className="fa-solid fa-scale-balanced icon"></i><p>Partidos por edad y nivel = <b>equilibrio y diversión.</b></p></div>
                <div className="card-small"><i className="fa-solid fa-hourglass-half icon"></i><p>Mínimo <b>40 minutos de juego</b> garantizados.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-solid fa-person-chalkboard icon"></i><p>Entrenador-guía que <b>arbitra y corrige.</b></p></div>
                <div className="card-small"><i className="fa-solid fa-shirt icon"></i><p><b>Equipaciones</b> de Liga ProKids.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-solid fa-briefcase-medical icon"></i><p>Seguro de <b>RC incluido</b> y <b>accidentes opcional.</b></p></div>
                <div className="card-small"><i className="fa-solid fa-up-down icon"></i><p><b>Flexibilidad total:</b> juega una jornada... o las 8.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-solid fa-lock-open icon"></i><p>Acceso a <b>contenido audiovisual</b> en nuestro grupo de WhatsApp.</p></div>
                <div className="card-small"><i className="fa-solid fa-share-nodes icon"></i><p><b>Visibilidad y menciones</b> en RRSS.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-solid fa-star icon"></i><p><b>Sistema ProPoints:</b> puntos por esfuerzo, rendimiento y constancia.</p></div>
              </div>
              <div className="card">
                <h4>LA MOTIVACIÓN QUE NECESITA</h4>
                <div className="card-content">
                  <p>Con el sistema ProPoints, tu hijo/a <b>acumula puntos</b> cada jornada, <b>desbloquea logros</b> individuales, <b>sube de nivel</b> y puede conseguir <b>regalos alucinantes</b>.</p>
                  <a href="/propoints-summer-edition" className="button">VER MÁS SOBRE EL SISTEMA PROPOINTS</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 5: CÓMO FUNCIONA */}
        <section id="como-funciona">
          <h2>¿CÓMO FUNCIONA LA SUMMER EDITION?</h2>
          <div className="row">
            <div className="col">
              <div className="article-card">
                <h3><i className="fa-solid fa-calendar-days icon"></i> FECHAS</h3>
                <article><ul><li><b>DEL 27 DE JUNIO AL 16 DE AGOSTO</b></li></ul></article>
              </div>
              <div className="article-card">
                <h3><i className="fa-solid fa-map-pin icon"></i> SEDES</h3>
                <article>
                  <ul>
                    <li><b>ALICANTE</b><ul><li><b><a href="https://maps.app.goo.gl/2HJYiFxUJ9QVLW886" target="_blank" rel="noreferrer">Campo Municipal Antonio Solana</a></b></li><li><b>Categorías:</b> Prebenjamín, benjamín, alevín, infantil (2019 - 2012).</li></ul></li>
                    <li><b>ALGORFA</b><ul><li><b><a href="https://maps.app.goo.gl/qeWLdRa7wNxvT4iK7" target="_blank" rel="noreferrer">Campo Municipal Juan Carlos I</a></b></li><li><b>Categorías:</b> Querubín, prebenjamín, benjamín, alevín, infantil (2021 - 2012).</li></ul></li>
                  </ul>
                </article>
              </div>
              <div className="article-card">
                <h3><i className="fa-solid fa-clock icon"></i> HORARIOS</h3>
                <article>
                  <ul>
                    <li><b>TODOS LOS SÁBADOS O DOMINGOS POR LA TARDE:</b><ul><li><b>Alicante:</b> partidos sábado por la tarde, cierre de inscripciones miércoles a las 23:59...</li><li><b>Algorfa:</b> partidos domingos por la tarde, cierre de inscripciones jueves a las 23:59...</li></ul></li>
                    <li><b>3 FRANJAS HORARIAS DE 90 MINUTOS</b></li>
                    <li><b>ENTRE LAS 17:00H Y LAS 21:30H</b></li>
                  </ul>
                </article>
              </div>
              <div className="article-card">
                <h3><i className="fa-solid fa-file-pen icon"></i> INSCRIPCIÓN</h3>
                <article>
                  <ul>
                    <li><b>INDIVIDUAL, CON ELECCIÓN DE SEDE</b></li>
                    <li><b>FLEXIBLE: PAGAS SOLO POR LAS JORNADAS QUE QUIERAS</b></li>
                    <li><b>INDICAS AÑO, POSICIÓN, DIVISIÓN...</b></li>
                  </ul>
                  <p>¡Tu hijo/a llega, coge su equipación, juega y se va feliz!</p>
                </article>
              </div>
              <h3>¿LO MEJOR?<br/>No hace falta comprometerse a todas las jornadas.</h3>
              <div className="card">
                <h4>PRECIO Y PACKS CON BENEFICIOS</h4>
                <div className="card-content">
                  <p>Descubre nuestros <b>packs</b> diseñados para que tu hijo/a disfrute al máximo de <b>Liga ProKids: Summer Edition</b>.</p>
                  <Link to={getRegisterUrl('summer')} className="button" style={{ width: '100%' }}>
                    <span>¡INSCRÍBETE AHORA!</span>
                    <br/>
                    <span>Regístrate <i className="fa-solid fa-arrow-right"></i> Crea futbolista <i className="fa-solid fa-arrow-right"></i> Compra jornadas</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6: PARA TI */}
        <section id="para-ti">
          <h2>LA SUMMER EDITION ES PARA TI SI...</h2>
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>Tu hijo/a no quiere dejar de <b>jugar en verano.</b></p></div>
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>Buscas una <b>experiencia distinta</b> a los campus.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>Quieres mantener a tu hijo/a <b>activo y motivado.</b></p></div>
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>Necesitas <b>flexibilidad</b> horaria.</p></div>
              </div>
              <div className="row">
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>Te gusta que el <b>esfuerzo tenga recompensa.</b></p></div>
                <div className="card-small"><i className="fa-regular fa-square-check icon"></i><p>No quieres que pase un <b>verano entero</b> sin fútbol.</p></div>
              </div>
              <div className="card">
                <h4>TU HIJO/A MERECE VIVIR ESTO</h4>
                <div className="card-content">
                  <p><b>¿Vas a dejarle todo el verano sin competir?</b></p>
                  <Link to={getRegisterUrl('summer')} className="button" style={{ width: '100%' }}>
                    <span>¡INSCRÍBETE AHORA!</span>
                    <br/>
                    <span>Regístrate <i className="fa-solid fa-arrow-right"></i> Crea futbolista <i className="fa-solid fa-arrow-right"></i> Compra jornadas</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 7: APUNTARTE */}
        <section id="apuntarte">
          <h2>¿POR QUÉ DEBERÍAS APUNTARTE?</h2>
          <div className="row">
            <div className="col">
              <div className="card-small"><i className="fa-solid fa-hand-point-right icon"></i><p>Porque <b>no hay nada igual</b> en verano.</p></div>
              <div className="card-small"><i className="fa-solid fa-hand-point-right icon"></i><p>Porque tu hijo/a <b>lo va a disfrutar</b> como nunca.</p></div>
              <div className="card-small"><i className="fa-solid fa-hand-point-right icon"></i><p>Porque las plazas serán <b>limitadas.</b></p></div>
              <div className="card">
                <h4>SI NO JUEGA AQUÍ...</h4>
                <div className="card-content">
                  <p><b>... ¿dónde va a jugar el próximo verano?</b></p>
                  <Link to={getRegisterUrl('summer')} className="button" style={{ width: '100%' }}>
                    <span>¡INSCRÍBETE AHORA!</span>
                    <br/>
                    <span>Regístrate <i className="fa-solid fa-arrow-right"></i> Crea futbolista <i className="fa-solid fa-arrow-right"></i> Compra jornadas</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 8: DUDAS */}
        <section id="dudas">
          <h2>¿TIENES ALGUNA DUDA O NECESITAS AYUDA?</h2>
          <div className="row">
            <div className="col image-container">
              <img src="/img/landing/imagen2.jpg" alt="Imagen liga" className="side-image" />
            </div>
            <div className="col">
              <div className="card">
                <h4>CONTACTA CON NOSOTROS</h4>
                <p>Si necesitas ayuda para inscribirte, contacta con nosotros y reservaremos tu plaza.</p>
                <a href="https://wa.me/34604972879" className="button whatsapp-button" target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-whatsapp"></i> <span>ENVIAR UN MENSAJE</span>
                </a>
              </div>
              <article>
                <p>Únete al grupo oficial de WhatsApp para estar al tanto de las últimas novedades.</p>
                <a href="https://chat.whatsapp.com/DqQrLox6plF0LRAzsXm8t2" className="button whatsapp-button" target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-whatsapp"></i> <span>GRUPO SEDE ALICANTE</span>
                </a>
                <a href="https://chat.whatsapp.com/Hbtc4naNG5dDny8qn116dW" className="button whatsapp-button" target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-whatsapp"></i> <span>GRUPO SEDE ALGORFA</span>
                </a>
              </article>
            </div>
          </div>
        </section>

        {/* SECTION 9: REVIEWS */}
        <section id="reviews">
          <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontSize: '45px', fontFamily: '"Oswald", sans-serif', color: '#ffffff', margin: '0 0 15px' }}>
              ¡ÚNETE A MÁS DE 900 FAMILIAS QUE YA HAN PARTICIPADO!
            </h2>

            {/* Google + estrellas */}
            <div style={{ marginBottom: '25px' }}>
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" alt="Google" style={{ height: '35px', marginBottom: '5px' }} />
              <div style={{ fontSize: '24px', color: '#FBBC05' }}>★★★★★</div>
            </div>

            {/* Review slider draggable */}
            <div
              style={{ overflow: 'hidden', cursor: isDragging ? 'grabbing' : 'grab', userSelect: 'none', maxWidth: '800px', margin: '0 auto' }}
              onMouseDown={(e) => { e.preventDefault(); handleDragStart(e.clientX); }}
              onMouseMove={(e) => handleDragMove(e.clientX)}
              onMouseUp={handleDragEnd}
              onMouseLeave={() => { if (dragStart.current !== null) handleDragEnd(); }}
              onTouchStart={(e) => handleDragStart(e.touches[0].clientX)}
              onTouchMove={(e) => handleDragMove(e.touches[0].clientX)}
              onTouchEnd={handleDragEnd}
            >
              <div style={{
                display: 'flex',
                transform: `translateX(calc(-${currentReview * 100}% + ${sliderTranslate}px))`,
                transition: isDragging ? 'none' : 'transform 0.3s ease',
              }}>
                {reviews.map((review, i) => (
                  <div key={i} style={{ minWidth: '100%', padding: '0 10px', boxSizing: 'border-box' }}>
                    <div style={{
                      backgroundColor: '#E8E8E8', borderRadius: '15px',
                      padding: '30px', textAlign: 'left',
                      boxShadow: 'inset #00446D 10px 0 0'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                        <img src={`/img/landing/testimonial-${i + 1}.png`} alt="" style={{ width: '60px', height: '60px', borderRadius: '50%' }} />
                        <div>
                          <h4 style={{ margin: 0, fontSize: '20px', color: '#000' }}>{review.name}</h4>
                          <i style={{ fontSize: '14px', color: '#666' }}>{review.sub}</i>
                        </div>
                      </div>
                      <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#333', margin: 0 }}>
                        {review.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dots */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '20px' }}>
              {reviews.map((_, i) => (
                <span key={i} onClick={() => setCurrentReview(i)} style={{
                  width: '12px', height: '12px', borderRadius: '50%', cursor: 'pointer',
                  backgroundColor: i === currentReview ? '#00446D' : 'rgba(0,0,0,0.2)',
                }} />
              ))}
            </div>
          </div>
        </section>

        {/* SECTION 10: PATROCINADORES */}
        <section id="patrocinadores" className="patrocinadores-section">
          <div className="container">
            <div className="section-title-wrapper">
              <h2 className="section-title">NUESTROS PATROCINADORES</h2>
            </div>
            <div className="sponsors-grid">
              <div className="sponsors-row main-sponsors">
                <img src="/img/1x/logo_telfy.png" alt="Telfy" className="sponsor-logo large" />
                <img src="/img/1x/ayto_algorfa.jpeg" alt="Ayuntamiento de Algorfa" className="sponsor-logo medium" />
              </div>
              <div className="sponsors-row other-sponsors">
                {['WS.jpg', 'RB.jpg', 'agromainsa.png', 'brithol2.png', 'imporecord.png'].map(logo => (
                  <img key={logo} src={`/img/1x/${logo}`} alt={logo.split('.')[0]} className="sponsor-logo small" />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SummerEdition;
